<template>
  <!-- <div class="qrcode-com" ref="qrcode_box"></div> -->
  <qrcode :value="text" :options="{ width: qrWidth }"></qrcode>
</template>

<script>
// import QRCode from 'qrcodejs2';
import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

export default {
  name: 'QrCode',
  props: {
    text: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 200,
    },
    // 是否自动更新、当text更改时自定刷新
    autoUpdate: {
      type: Boolean,
      default: true,
    },
    qrWidth: {
      type: String,
      default: '160'
    }
  },
  data () {
    return {
      // qrObj: null
    };
  },
  methods: {
    // create() {
    //   if (!this.qrObj) {
    //     this.qrObj = new QRCode(this.$refs.qrcode_box, {
    //       text: this.text,
    //       width: this.width,
    //       height: this.height
    //     });
    //   }
    // },
    // update(text) {
    //   if (this.qrObj) {
    //     this.qrObj.makeCode(text || this.text);
    //   }
    // }
  },
  watch: {
    /* text (text) {
      if (this.autoUpdate) {
        this.update(text);
      }
    } */
    // text: {
    //   immediate: true,
    //   handler (text) {
    //     if (text) {
    //       if (this.qrObj) {
    //         if (this.autoUpdate) {
    //           this.update(text);
    //         }
    //       } else {
    //         this.$nextTick(() => {
    //           this.create();
    //         });
    //       }
    //     }
    //   },
    // },
  },
  /* mounted () {
     this.$nextTick(() => {
       this.create();
     });
   }, */
  beforeDestroy () {
    /* if (this.qrObj) {
      try {
        this.qrObj.destroy();
      } catch (e) {
        console.error('销毁二维码控件失败', e);
      }
    } */
  },
};
</script>
